import { DateSeries } from '../';
import { RemoteMixin } from '../../RemoteMixin';

export class RemoteDateSeries extends RemoteMixin(DateSeries) { }